import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import { api } from "../../Constant";
import axios from 'axios';
import Popup from "../RegisterScreen/Popup";
import lovebg from "../../assets/images/love-bg.png";

function Bestselling({ onCartUpdate }) {
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [isWishlistActive, setIsWishlistActive] = useState({});
  const [username, setUsername] = useState("");
  const [userid, setUserid] = useState("");
  const [type, setType] = useState("");
  const [bestselling, setBestselling] = useState([]);

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1320, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      { breakpoint: 1199, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };
  useEffect(() => {
    axios.post(api + "featured_product_list")
      .then((response) => {
        if (response.data.success === 'true') {
          const featuredProducts = response.data.featured_products;
          const bestselling = featuredProducts.find(item => item.title === "Best Selling");
          if (bestselling) {
            setBestselling(bestselling.products);
          } else {
            console.log("Best Selling section not found");
          }
        } else {
          console.log('No featured products found');
        }
      })
      .catch((error) => {
        console.log('Error:', error);
      });
  }, []);

  useEffect(() => {
    const storedUsername = localStorage.getItem('userName');
    const storeUserid = localStorage.getItem('userId');
    setUsername(storedUsername || "");
    setUserid(storeUserid || "");
    if (storeUserid) {
      axios.post(api + "wishlist", { user_id: storeUserid })
        .then((response) => {
          if (response.data.success === "true") {
            const wishlistProducts = response.data.product;
          
            const wishlistState = wishlistProducts.reduce((acc, product) => {
              acc[product.product_id] = true;
              return acc;
            }, {});
            setIsWishlistActive(wishlistState);
          } else {
            console.log("No products found in wishlist");
          }
        })
        .catch((error) => {
          console.log("Error fetching wishlist:", error);
        });
    }
  }, []);
  const handleClosePopup = () => {
    setPopupVisible(false);
  };

  const whishlistClick = (productId) => {
    if (!username) {
      setPopupMessage("Please log in to use the wishlist feature.");
      setType("error");
      setPopupVisible(true);
      return;
    }

    const apiEndpoint = isWishlistActive[productId] ? "remove_wishlist" : "add_wishlist";
    const successMessage = isWishlistActive[productId]
      ? "Product removed successfully from Wishlist."
      : "Wishlist added successfully.";

    axios.post(api + apiEndpoint, {
      user_id: userid,
      product_id: productId,
    })
      .then((response) => {
        if (response.data.success === "true") {
          setPopupMessage(successMessage);
          setType("success");
          setIsWishlistActive((prevState) => ({
            ...prevState,
            [productId]: !prevState[productId]
          }));
        } else {
          setPopupMessage("Failed to update wishlist.");
          setType("error");
        }
        setPopupVisible(true);
      })
      .catch((error) => {
        setPopupMessage("An error occurred while updating the wishlist.");
        setType("error");
        setPopupVisible(true);
      });
  };

 const navigate = useNavigate('')
  const productdetailmove = (product_id)=>{
    navigate(`/product-detail/${product_id}`)

  }
  return (
    <section className="best_selling_home_section pt-5 pb-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <h2 className="heading-1">Best Selling</h2>
          </div>
        </div>
        <div className="row second_row">
          <Slider {...settings}>
            {bestselling.map((item) => (
              <div className="products_card" key={item.product_id}>
               <div
  className="inner-box"
  style={{
    backgroundImage: `url(${lovebg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: "12px", // optional
    overflow: "hidden",   // keeps child img neat
  }}
>
  <div className="img_box">
    <img src={item.product_image} alt="product_img" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
  </div>
  <div className="content_box">
    <p>{item.name}</p>
 {Number(item.discount_price) > 0 ? (
  <h6>
    ₹ {item.discount_price}
    <span
      style={{
        textDecoration: "line-through",
        marginLeft: "10px",
        color: "gray",
        fontSize: "14px",
      }}
    >
      ₹ {item.price}
    </span>
  </h6>
) : (
  <h6>₹ {item.price}</h6>
)}

  </div>
  <div className="btn_box" onClick={() => productdetailmove(item.product_id)}>
    <a>Shop now</a>
  </div>
  <div className="wishlist_btn" onClick={() => whishlistClick(item.product_id)} style={{ cursor: 'pointer' }}>
    <FontAwesomeIcon
      icon={faHeart}
      style={{ color: username && isWishlistActive[item.product_id] ? "#92ad69" : "rgb(191, 191, 191)" }}
    />
  </div>
</div>

              </div>
            ))}
          </Slider>
        </div>
        {popupVisible && (
          <Popup
            message={popupMessage}
            title="Notice"
            type={type}
            onClose={handleClosePopup}
          />
        )}
      </div>
    </section>
  );
}

export default Bestselling;
